import React, { ElementType, FC } from 'react';
import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import styled from '@emotion/styled';
import { getHtmlId, useNumberedNode } from '../../numbering';
import { BlockNode } from '../BlockNode';

const StyledNodeViewContent = styled(NodeViewContent)<{ numbering: string }>`
  & > :before {
    content: '${({ numbering }) => numbering} ';
  }
`;

export const HeadingView: FC<NodeViewProps> = (props) => {
  const node = useNumberedNode(props.node.attrs.id, props.editor);

  const asComponent = `h${props.node.attrs.level}` as keyof JSX.IntrinsicElements;
  return (
    <NodeViewWrapper className="react-component" id={node ? getHtmlId(node) : ''}>
      <BlockNode props={props}>
        <StyledNodeViewContent as={asComponent} numbering={node?.numbering ?? ''}></StyledNodeViewContent>
      </BlockNode>
    </NodeViewWrapper>
  );
};
